export default __webpack_public_path__ + "static/savings-e974a928d64851389bccda11070bfabf.png";